// Lire plus / Lire moins — hero desktop
(function () {
  function initHeroReadMore() {
    var btn = document.querySelector('.mm-hero-co-read-more');
    if (!btn) return;
    var wrapper = btn.closest('.mm-hero-co-desc-wrapper');
    if (!wrapper) return;
    var extract = wrapper.querySelector('.mm-hero-co-desc--extract');
    var full = wrapper.querySelector('.mm-hero-co-desc--full');
    if (!extract || !full) return;
    btn.addEventListener('click', function () {
      var isExtract = !extract.classList.contains('mm-hero-co-desc--hidden');
      if (isExtract) {
        extract.classList.add('mm-hero-co-desc--hidden');
        full.style.display = 'block';
        btn.textContent = 'Lire moins';
      } else {
        full.style.display = 'none';
        extract.classList.remove('mm-hero-co-desc--hidden');
        btn.textContent = 'Lire plus';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeroReadMore();
  });
})();

// Lire la suite / Lire moins — breaking block grille mobile
function mmHeroBgToggleDesc(btn) {
  var block = btn.closest('.mm-hero-block-grid-inner');
  if (!block) return;
  var extract = block.querySelector('.mm-hero-co-desc--extract');
  var full = block.querySelector('.mm-hero-co-desc--full');
  if (!extract || !full) return;
  var isExtract = !extract.classList.contains('mm-hero-co-desc--hidden');
  if (isExtract) {
    extract.classList.add('mm-hero-co-desc--hidden');
    full.style.display = 'block';
    btn.textContent = 'Lire moins';
  } else {
    full.style.display = 'none';
    extract.classList.remove('mm-hero-co-desc--hidden');
    btn.textContent = 'Lire la suite';
  }
}

// Voir plus / Voir moins — localisation breaking block
function mmHeroBgToggleLoc(btn) {
  var container = btn.closest('.mm-hero-bg-loc-pills');
  if (!container) return;
  var hidden = container.querySelectorAll('.mm-hero-bg-loc-hidden');
  var isExpanded = btn.dataset.expanded === '1';
  hidden.forEach(function (el) {
    el.style.display = isExpanded ? 'none' : 'flex';
  });
  btn.textContent = isExpanded ? 'Voir plus' : 'Voir moins';
  btn.dataset.expanded = isExpanded ? '0' : '1';
}

// Ouvre le panneau filtres mobile (défini ici pour garantir la disponibilité depuis le hero)
function mmOpenFiltersMobile() {
  var wrapperMobile = document.querySelector('.mm-filters-container');
  var filterCta = document.querySelector('.filter-form');
  var wrapperMobileFilter = document.querySelector('.mm-wrapper-filter-bg');
  if (!wrapperMobile || !wrapperMobileFilter) return;
  wrapperMobile.classList.add('mm-filter-mobile-style');
  wrapperMobile.classList.add('mm-open');
  wrapperMobile.style.display = 'flex';
  wrapperMobileFilter.style.display = 'block';
  if (filterCta) filterCta.style.zIndex = '3';
  document.querySelector('html').classList.add('stop-scrolling');
  setTimeout(function () {
    if (typeof reloadAccordeonsProductForm === 'function') reloadAccordeonsProductForm();
    if (typeof updateCheckedCount === 'function') updateCheckedCount();
  }, 100);
}

// Sync select tri du breaking block avec le formulaire principal
function mmSyncSortGrid(select) {
  var main = document.querySelector('#SortBy');
  if (main) {
    main.value = select.value;
    main.dispatchEvent(new Event('change'));
  } else {
    select.form && select.form.requestSubmit && select.form.requestSubmit();
  }
}

// Sync le compteur de produits mobile depuis #ProductCount
function mmSyncMobileProductCount() {
  var countEl = document.querySelector('#ProductCount');
  var mobileEl = document.querySelector('.mm-count-title-hco-mobile');
  if (!countEl || !mobileEl) return;
  var count = countEl.innerText.trim();
  mobileEl.innerHTML = count + '<span> produits</span>';
}

// Sync la valeur du select tri mobile depuis #SortBy
function mmSyncMobileSortSelect() {
  var main = document.querySelector('#SortBy');
  var mobile = document.querySelector('#SortByMobile');
  if (main && mobile) mobile.value = main.value;
}

// Masque #main-collection-filters quand .mm-hero-bg-sort-filter est visible

// #main-collection-filters est masqué par défaut en CSS sur mobile (le hero a son propre bloc de filtres).
// On ne le réaffiche que si le hero n'est pas présent sur la page.
(function () {
  function initSortFilterVisibility() {
    var heroSortFilter = document.querySelector('.mm-hero-bg-sort-filter');
    var mainFilters = document.querySelector('#main-collection-filters');
    if (!heroSortFilter || !mainFilters) return;

    var observer = new IntersectionObserver(function (entries) {
      var isVisible = entries[0].isIntersecting;
      mainFilters.classList.toggle('mm-hidden-by-hero', isVisible);
    }, { threshold: 0 });

    observer.observe(heroSortFilter);
  }

  document.addEventListener('DOMContentLoaded', initSortFilterVisibility);
})();

document.addEventListener('DOMContentLoaded', function () {
  // Renommer le form dupliqué dans le hero pour éviter le conflit avec celui de la grid
  var heroFacets = document.querySelector('.mm-hero-facets-mobile');
  if (heroFacets) {
    var heroForm = heroFacets.querySelector('#collectionFacetsForm');
    if (heroForm) {
      heroForm.id = 'collectionFacetsFormHero';
      // Synchroniser les changements du form hero vers le form principal
      heroForm.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('change', function () {
          var mainCb = document.querySelector('#collectionFacetsForm input[name="' + input.name + '"][value="' + input.value + '"]');
          if (mainCb) {
            mainCb.checked = input.checked;
            mainCb.dispatchEvent(new Event('change'));
          }
        });
      });
    }
  }
  mmSyncMobileProductCount();
  mmSyncMobileSortSelect();
});
